import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import EmailIcon from '@material-ui/icons/Email';
import Button from '@material-ui/core/Button';
import { authHeader } from '../../components/auth-header';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Card from '@material-ui/core/Card';
import { AppBar, Toolbar } from '@material-ui/core'
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import { withSnackbar } from 'material-ui-snackbar-provider'

const formControlStyle = {
    marginLeft: 8
};

class InseminationList extends Component {
    static displayName = InseminationList.name;

    constructor(props) {
        super(props);

        var comp = this;
        var inseminations = [];
        var calvingReports = [];
        this.removeInsemination = this.removeInsemination.bind(this);
        this.isInsemInvalid = this.isInsemInvalid.bind(this);
        this.sync = this.sync.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderInseminationsTable = this.renderInseminationsTable.bind(this);
        this.renderBusyIndicator = this.renderBusyIndicator.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChangePageCalvings = this.handleChangePageCalvings.bind(this);
        this.handleChangeRowsPerPageCalvings = this.handleChangeRowsPerPageCalvings.bind(this);

        inseminations = localStorage.getItem("inseminations") ? JSON.parse(localStorage.getItem("inseminations")) : [];
        calvingReports = localStorage.getItem("calvingReports") ? JSON.parse(localStorage.getItem("calvingReports")) : [];
        comp.state = { inseminations: inseminations, calvingReports: calvingReports, loading: true, page: 0, rowsPerPage: 10, pageCalvings: 0, rowsPerPageCalvings: 10 };

        fetch('api/Insemination/SyncInseminationsForUser', {
            headers: { 'Content-Type': 'application/json', 'Authorization': authHeader().Authorization },
            method: 'post',
            body: JSON.stringify(calvingReports.concat(inseminations))
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    inseminations = data.filter(d => !d.calvingResult);
                    localStorage.setItem("inseminations", JSON.stringify(inseminations.filter(ins => !ins.inseminationDataSyncBatchId)));
                    calvingReports = data.filter(d => d.calvingResult);
                    localStorage.setItem("calvingReports", JSON.stringify(calvingReports.filter(ins => !ins.inseminationDataSyncBatchId)));
                    comp.setState({ inseminations: inseminations, calvingReports: calvingReports, loading: false });
                    comp.props.snackbar.showMessage('Vaše dáta boli synchronizované.');
                } else {
                    comp.setState({ inseminations: inseminations, calvingReports: calvingReports, loading: false });
                }

            }).catch(function (err) {
                comp.setState({ loading: false });
            });
    }

    handleChangePageCalvings = (event, pageCalvings) => {
        this.setState({ pageCalvings });
    };

    handleChangeRowsPerPageCalvings = event => {
        this.setState({ rowsPerPageCalvings: event.target.value });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    sync() {
        var compo = this;
        if (!this.state.email) {
            this.setState({ emailError: true });
            return;
        }
        if ((!localStorage.getItem('inseminations') || JSON.parse(localStorage.getItem('inseminations')).filter(ins => !ins.inseminationDataSyncBatchId).length === 0) && (!localStorage.getItem('calvingReports') || JSON.parse(localStorage.getItem('calvingReports')).filter(ins => !ins.inseminationDataSyncBatchId).length === 0)) {
            compo.props.snackbar.showMessage('Žiadne dáta k odoslaniu');
            return;
        }

        compo.setState({ loading: true });
        fetch('api/Synchronization/Sync', {
            headers: { 'Content-Type': 'application/json', 'Authorization': authHeader().Authorization },
            method: 'post',
            body: JSON.stringify({
                inseminations: localStorage.getItem('inseminations') ? JSON.parse(localStorage.getItem('inseminations')).filter(ins => !ins.inseminationDataSyncBatchId) : [],
                calvingReports: localStorage.getItem('calvingReports') ? JSON.parse(localStorage.getItem('calvingReports')).filter(ins => !ins.inseminationDataSyncBatchId) : [],
                email: compo.state.email
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.invalid || data.message) {
                    if (data.message) {
                        compo.props.snackbar.showMessage(data.message);
                    } else {
                        compo.props.snackbar.showMessage("Vytvorenie a odoslanie dávky sa nepodarilo, prosím opravte chybné polia");

                        var finalInseminations = this.state.inseminations.filter(ins => ins.inseminationDataSyncBatchId);
                        var finalCalvingReports = this.state.calvingReports.filter(ins => ins.inseminationDataSyncBatchId);
                        finalInseminations = finalInseminations.concat(data.inseminations);
                        finalCalvingReports = finalCalvingReports.concat(data.calvingReports);

                        localStorage.setItem('inseminations', JSON.stringify(data.inseminations));
                        localStorage.setItem('calvingReports', JSON.stringify(data.calvingReports));
                        compo.setState({ calvingReports: finalCalvingReports, inseminations: finalInseminations });
                    }
                } else {
                    compo.props.snackbar.showMessage("Vytvorenie a odoslanie dávky prebehlo úspešne");
                    localStorage.setItem('inseminations', []);
                    localStorage.setItem('calvingReports', []);
                    window.location.reload();
                }
                compo.setState({ loading: false });
            }).catch(function (err) {
                compo.props.snackbar.showMessage("Vytvorenie a odoslanie dávky sa nepodarilo, pravdepodobne nemáte pripojenie k internetu.");
                compo.setState({ loading: false });
            });
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });

    }
    removeInsemination(insemination, isCalvingReport) {
        var alertStr = isCalvingReport ? "Hlásenie teľnosti bolo vymazané" : "Inseminácia bola vymazaná.";
        var comp = this;

        fetch('api/Insemination/DeleteInsemination?id=' + insemination.id, {
            headers: { 'Authorization': authHeader().Authorization },
            method: 'delete'
        })
            .then(response => response.json())
            .then(data => {
                if (isCalvingReport) {
                    comp.removeCalvingReportFromStorage(insemination)
                } else {
                    comp.removeInseminationFromStorage(insemination);
                }

                comp.props.snackbar.showMessage(alertStr + ".");
            }).catch(function (err) {
                if (isCalvingReport) {
                    comp.removeCalvingReportFromStorage(insemination)
                } else {
                    comp.removeInseminationFromStorage(insemination);
                }

                comp.props.snackbar.showMessage(alertStr + " lokálne.");
            });

    }

    removeInseminationFromStorage(insemination) {
        var inseminations = localStorage.getItem("inseminations") ? JSON.parse(localStorage.getItem("inseminations")) : [];
        inseminations = inseminations.filter(ins => insemination.id ? (ins.id !== insemination.id) : (ins.animalCode !== insemination.animalCode || ins.dateInsem !== insemination.dateInsem));
        localStorage.setItem("inseminations", JSON.stringify(inseminations));

        var stateInseminations = this.state.inseminations.filter(ins => insemination.id ? (ins.id !== insemination.id) : (ins.animalCode !== insemination.animalCode || ins.dateInsem !== insemination.dateInsem));
        this.setState({ inseminations: stateInseminations});
    }

    removeCalvingReportFromStorage(insemination) {
        var calvingReports = localStorage.getItem("calvingReports") ? JSON.parse(localStorage.getItem("calvingReports")) : [];
        calvingReports = calvingReports.filter(ins => insemination.id ? (ins.id !== insemination.id) : (ins.animalCode !== insemination.animalCode || ins.dateInsem !== insemination.dateInsem));
        localStorage.setItem("calvingReports", JSON.stringify(calvingReports));

        var stateCalvingReports = this.state.calvingReports.filter(ins => insemination.id ? (ins.id !== insemination.id) : (ins.animalCode !== insemination.animalCode || ins.dateInsem !== insemination.dateInsem));
        this.setState({ calvingReports: stateCalvingReports });
    }
    

    isInsemInvalid(insemination) {
        return insemination.invalidFields &&
            (insemination.invalidFields.filter(field => field !== 'prestajnenie' && field !== 'prestajnenieOk').length > 0 || (insemination.invalidFields.indexOf("prestajnenie") !== -1 && insemination.invalidFields.indexOf("prestajnenieOk") === -1)) &&
            (insemination.invalidFields.filter(field => field !== 'animalCode' && field !== 'animalCodeOk').length > 0 || (insemination.invalidFields.indexOf("animalCode") !== -1 && insemination.invalidFields.indexOf("animalCodeOk") === -1));
    }

    renderBusyIndicator(props) {
        return (
            <Paper style={{ padding: 15 }}>
                <CircularProgress className={props.progress} />
            </Paper>
        );
    }

    renderInseminationsTable(inseminations) {
        const { rowsPerPage, page } = this.state;

        if (!inseminations || inseminations.length === 0) {
            return (
                <Paper>
                    <List padding="none">
                        <ListItem>
                            <ListItemText>Žiadne výsledky </ListItemText>
                        </ListItem>
                    </List>
                </Paper>
            );
        } else {
            return (
                <Paper>
                    <Table padding="none">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ padding: 5, minWidth: 10, textAlign: "left" }}>
                                </TableCell>
                                <TableCell style={{ paddingLeft: 0, paddingRight: 2, textAlign: "center" }}>Ušné číslo</TableCell>
                                <TableCell style={{ padding: 0, textAlign: "center" }}>Dátum</TableCell>
                                <TableCell style={{ padding: 5, textAlign: "center" }}>Akcie</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {inseminations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(insemination =>

                                <TableRow style={{ cursor: insemination.inseminationDataSyncBatchId ? 'not-allowed' : 'pointer' }} hover={insemination.inseminationDataSyncBatchId ? false : true} key={insemination.animalCode + insemination.dateInsem + insemination.id}>
                                    <TableCell onClick={() => { if (!insemination.inseminationDataSyncBatchId) { this.props.history.push("/insemination-detail/" + insemination.id + "/" + insemination.animalCode + "/" + insemination.dateInsem) } }} style={{ padding: 5, minWidth: 10, textAlign: 'left' }}>
                                        {this.isInsemInvalid(insemination) ? <ErrorIcon style={{ color: 'red', verticalAlign: 'text-bottom' }} /> : ''}
                                        {insemination.inseminationDataSyncBatchId ? <EmailIcon style={{ color: 'gray', verticalAlign: 'text-bottom' }} /> : ''}
                                    </TableCell>
                                    <TableCell onClick={() => { if (!insemination.inseminationDataSyncBatchId) { this.props.history.push("/insemination-detail/" + insemination.id + "/" + insemination.animalCode + "/" + insemination.dateInsem) } }}  style={{ paddingLeft: 0, paddingRight: 2, textAlign: "center" }}>
                                        {insemination.animalCode}
                                    </TableCell>

                                    <TableCell onClick={() => { if (!insemination.inseminationDataSyncBatchId) { this.props.history.push("/insemination-detail/" + insemination.id + "/" + insemination.animalCode + "/" + insemination.dateInsem) } }}  style={{ padding: 0, textAlign: "center" }}>{insemination.dateInsem}</TableCell>

                                    <TableCell style={{ padding: 5, textAlign: "center" }} onClick={() => { if (insemination.inseminationDataSyncBatchId) return; this.removeInsemination(insemination, false); }}>
                                        <IconButton disabled={insemination.inseminationDataSyncBatchId ? true : false} color="secondary" aria-label="Delete">
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>

                                </TableRow>

                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={this.state.inseminations.length}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage='Počet záznamov'
                        page={page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </Paper>
            );
        }

    }

    renderCalvingReportsTable(calvingReports) {
        const { rowsPerPageCalvings, pageCalvings } = this.state;

        if (!calvingReports || calvingReports.length === 0) {
            return (
                <Paper>
                    <List padding="none">
                        <ListItem>
                            <ListItemText>Žiadne výsledky </ListItemText>
                        </ListItem>
                    </List>
                </Paper>
            );
        } else {
            return (
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ padding: 5, minWidth: 10, textAlign: "left" }}></TableCell>
                                <TableCell style={{ padding: 0, paddingRight: 2, textAlign: "center" }}>Ušné číslo</TableCell>
                                <TableCell style={{ padding: 0, textAlign: "center" }}>Dátum</TableCell>
                                <TableCell style={{ padding: 5, textAlign: "center" }}>Vyšetrenie</TableCell>
                                <TableCell style={{ padding: 5, textAlign: "center" }}>Akcie</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {calvingReports.slice(pageCalvings * rowsPerPageCalvings, pageCalvings * rowsPerPageCalvings + rowsPerPageCalvings).map(calvingReport =>
                                <TableRow style={{ cursor: calvingReport.inseminationDataSyncBatchId ? 'not-allowed' : 'inherit' }} disabled={calvingReport.inseminationDataSyncBatchId ? true : false} key={calvingReport.animalCode + calvingReport.dateInsem + calvingReport.id}>
                                    <TableCell style={{ padding: 5, minWidth: 10, textAlign: 'left' }}>
                                        {calvingReport.inseminationDataSyncBatchId ? <EmailIcon style={{ color: 'gray', verticalAlign: 'text-bottom' }} /> : ''}
                                    </TableCell>
                                    <TableCell style={{ padding: 0, paddingRight: 2, textAlign: "center" }}>
                                        {calvingReport.animalCode}
                                    </TableCell>
                                    <TableCell style={{ padding: 0, textAlign: "center" }} >{calvingReport.dateInsem} </TableCell>
                                    <TableCell style={{ padding: 5, textAlign: "center" }}>{calvingReport.calvingResult} </TableCell>
                                    <TableCell style={{ padding: 5, textAlign: "center" }} onClick={() => { if (calvingReport.inseminationDataSyncBatchId) return; this.removeInsemination(calvingReport, true); }}>
                                        <IconButton disabled={calvingReport.inseminationDataSyncBatchId ? true : false} aria-label="Delete" color="secondary">
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={this.state.calvingReports.length}
                        rowsPerPage={rowsPerPageCalvings}
                        labelRowsPerPage='Počet záznamov'
                        page={pageCalvings}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePageCalvings}
                        onChangeRowsPerPage={this.handleChangeRowsPerPageCalvings}
                    />
                </Paper>
            );
        }

    }

    render() {

        let contents = this.state.loading ? this.renderBusyIndicator(this.props) : this.renderInseminationsTable(this.state.inseminations.sort(function (a, b) { return a.id > b.id ? -1 : 1; }).sort(function (a, b) { return a.dateInsem > b.dateInsem ? -1 : 1; }).sort(function (a, b) { return a.inseminationDataSyncBatchId ? 1 : -1; }));
        let calvingReports = this.state.loading ? this.renderBusyIndicator(this.props) : this.renderCalvingReportsTable(this.state.calvingReports.sort(function (a, b) { return a.id > b.id ? -1 : 1; }).sort(function (a, b) { return a.dateInsem > b.dateInsem ? -1 : 1; }).sort(function (a, b) { return a.inseminationDataSyncBatchId ? 1 : -1; }));
        return (
            <div className={this.props.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={this.props.grow} variant="h6" color="inherit">Inseminácie</Typography>
                    </Toolbar>
                </AppBar>
                {contents}
                <br />
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={this.props.grow} variant="h6" color="inherit">Hlásenia teľnosti</Typography>
                    </Toolbar>
                </AppBar>
                {calvingReports}
                <br />
                <Card>
                    <FormControl error={this.state.emailError} style={formControlStyle} margin="normal" required >
                        <InputLabel htmlFor="email">Email</InputLabel>
                        <Input type="email" id="email" name="email" value={this.state.email} onChange={this.handleChange} />
                    </FormControl>
                    <CardActions>
                        <Button
                            onClick={() => { this.sync(); }}
                            variant="contained"
                            color="secondary"
                        >Odošli</Button>
                    </CardActions>

                </Card>

            </div>
        );
    }
}
export default withSnackbar()(InseminationList)


// WEBPACK FOOTER //
// ./src/components/technik/InseminationList.jsx